import Importable from './importable'
import _ from 'lodash'

var Import = Importable.extend({

	urlRoot: 'api/imports',

	getSourceDataPreviewUrl: function() {
		return 'api/imports/validate-spreadsheet'
	},

	getUploadSpreadsheetUrl: function() {
		return 'api/imports/spreadsheets'
	},

	getUploadExternalFileUrl: function() {
		return 'api/imports/spreadsheets/external'
	},

	getValidateDbConnectionUrl: function() {
		return 'api/imports/validate-db-connection'
	},

	getTransformationPreviewUrl: function() {
		return 'api/imports/transformation-preview'
	},

	/**
	 * Clears status related fields from model
	 */
	clearStatus: function () {
		var unset = ['lastImportStatus', 'lastImportTime', 'lastSuccessCount',
			'lastFailedCount', 'lastPendingCount', 'importStatus']
		_.each(unset,key => {
			this.unset(key)
		})
	},

	headerRowSelected: function() {
		return this.getDataSourceMetadata().header
	},

	/**
	 * Returns the index of the selected header row
	 */
	headerRowIndex: function () {
		// #32110 if we already have a header row index, just return that
		let headerRow = this.getDataSourceMetadata('headerRow')
		if (!_.isNil(headerRow)) {
			return headerRow
		}
		// determine the header row
		let headerIndex
		// if the model is new, this always will be zero (the first row)
		if (this.isNew() && _.isNil(this.headerRowSelected())) {
			headerIndex = 0
		}

		// if we have any ignore rows and this import is using a header row,
		// the header row will be the next row after any consecutive ignored
		// rows at the beginning of the file
		if (this.headerRowSelected()) {
			// only use the ignored rows at the beginning of the spreadsheet
			let ignoreRows = this.getValidIgnoreRows()
			if (!_.isEmpty(ignoreRows)) {
				headerIndex = _.last(ignoreRows) + 1
			} else {
				headerIndex = 0
			}
		}
		return headerIndex
	},

	/**
	 * Provides label information to be used for building titles and messages
	 * throughout the steps of wizards (vi-wizard.js, data-source-info-wizard.js)
	 * @param type
	 * @returns {{plural: string, singular: string}}
	 */
	labelCodes: function() {
		let labels
		let type = this.get('type')
		if (type === 'initiative-status') {
			labels = {
				singular: 'admin.import.scheduled.initiative-status', // Initiative Status
				plural: 'admin.import.scheduled.initiative-status' // Initiative Status
			}
		} else if (type === 'metric-value') {
			labels = {
				singular: 'scorecards.node.metric.actual', // KPI Value
				plural: 'admin.import.scheduled.metric-value' // KPI Values
			}
		}
		return labels
	}

}, {
	// from ImportType.java
	METRIC_VALUE: 'metric-value',
	INITIATIVE_STATUS: 'initiative-status',
	SCORECARD_ITEM: 'scorecard-item',
	INITIATIVE_ITEM: 'initiative-item'
})

export default Import

Import.__filename__ = 'imports/model/import.js'
